import { useState, useEffect } from 'react'

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const media = window.matchMedia(query)

    // Definir estado inicial
    setMatches(media.matches)

    // Listener para mudanças
    const listener = (e: MediaQueryListEvent) => {
      setMatches(e.matches)
    }

    // Modern browsers
    if (media.addEventListener) {
      media.addEventListener('change', listener)
      return () => media.removeEventListener('change', listener)
    }

    // Fallback para browsers antigos
    media.addListener(listener)
    return () => media.removeListener(listener)
  }, [query])

  return matches
}
